var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStairs24DpFill1Wght300Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407-383h73q12.75 0 21.37-8.63Q510-400.25 510-413v-103h73q12.75 0 21.37-8.63Q613-533.25 613-546v-104h67q12.75 0 21.37-8.63 8.63-8.63 8.63-21.38 0-12.76-8.63-21.37Q692.75-710 680-710h-97q-12.75 0-21.37 8.63Q553-692.75 553-680v103h-73q-12.75 0-21.37 8.63Q450-559.75 450-547v103h-73q-12.75 0-21.37 8.63Q347-426.75 347-414v104h-67q-12.75 0-21.37 8.63-8.63 8.63-8.63 21.38 0 12.76 8.63 21.37Q267.25-250 280-250h97q12.75 0 21.37-8.63Q407-267.25 407-280v-103ZM212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h535.38Q778-820 799-799q21 21 21 51.31v535.38Q820-182 799-161q-21 21-51.31 21H212.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs24DpFill1Wght300Grad0Opsz24);
export default __webpack_public_path__ + "static/media/stairs_24dp_FILL1_wght300_GRAD0_opsz24.3971b5ca2ad727c40406218729eeb4f0.svg";
export { ForwardRef as ReactComponent };